import Volume from '../../src/legacy/Volume';
export default Volume;
